export const cityNames: {[cityId:number]:string} = {
    1: "zaporizhzhia",
    2: "dnipro",
    9: "kharkiv",
    3: "ivano-frankivsk",
    10: "khmelnytskyi",
    11: "sumy",
    19: "cherkasy"
}